import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import logo from '../assets/Preview.png';

function Header() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogoClick = () => {
    navigate('/');
    setMenuOpen(false);
  };

  const handleContactClick = () => {
    navigate('/contact');
    setMenuOpen(false);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="logo-container" onClick={handleLogoClick}>
        <img
          src={logo}
          alt="Cyber Tech Solutions Logo"
          className="logo-image"
        />

        <div className="logo-text">
          Cyber Tech Solutions
        </div>
      </div>

      {/* Desktop Navigation */}
      <nav className="nav desktop-nav">
        <ul>
          <li>
            <a href="#services">Services</a>
          </li>

          <li>
            <a href="#testimonials">Testimonials</a>
          </li>

          <li>
            <button
              className="nav-link"
              onClick={handleContactClick}
            >
              Contact
            </button>
          </li>
        </ul>
      </nav>

      {/* Mobile Menu Button */}
      <button
        className="mobile-menu-button"
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation menu"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Mobile Navigation */}
      <nav className={`mobile-nav ${menuOpen ? 'mobile-nav-open' : ''}`}>
        <ul>
          <li>
            <a href="#services" onClick={closeMenu}>
              Services
            </a>
          </li>

          <li>
            <a href="#testimonials" onClick={closeMenu}>
              Testimonials
            </a>
          </li>

          <li>
            <button
              className="nav-link"
              onClick={handleContactClick}
            >
              Contact
            </button>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;